export default {
    intro: 'Hãy điền vào chỗ trống để hoàn thành bảng!',
};
